<template>
	<div class="subheader">
		<div class="container">
			<div class="subheader-left">
				<span class="subheader-subtitle" v-if="subtitulo">{{ subtitulo }}</span>
				<h1>{{ titulo }}</h1>
			</div>
			<div class="subheader-right" v-if="hayEspectaculoDestacado">
				<span class="destacado-title">Espectáculo destacado</span>
				<a @click="irAEspectaculo(espectaculoDestacado.id)" class="destacado" :class="{ 'destacado-alternativo': !espectaculoDestacado.requiereInstituciones, 'espectaculo-agotado': espectaculoDestacado.isAgotado, 'espectaculo-abono': espectaculoDestacado.esAbono }">
					<div class="espectaculo-agotado-overlay" v-if="espectaculoDestacado.isAgotado">
						<span>Localidades agotadas</span>
					</div>
					<div class="espectaculo-tipo" :style="{ 'background-color' : '#' + espectaculoDestacado.tipoColor }">{{ espectaculoDestacado.tipoNombre }}</div>
					<div class="espectaculo-top" v-if="!espectaculoDestacado.EspectaculoTipoRequiereInstitucion && espectaculoDestacado.miniatura">
						<img class="espectaculo-miniatura" :src="espectaculoDestacado.miniatura" :alt="espectaculoDestacado.EspectaculoNombre">
					</div>
					<div class="espectaculo-top" v-if="espectaculoDestacado.requiereInstituciones">
						<div class="equipo equipo-local">
							<img :src="espectaculoDestacado.institucionLocalEscudo" :alt="espectaculoDestacado.institucionLocalNombre">
							<span>{{ espectaculoDestacado.institucionLocalNombre }}</span>
						</div>
						<span class="vs">vs.</span>
						<div class="equipo equipo-visitante">
							<img :src="espectaculoDestacado.institucionVisitanteEscudo" :alt="espectaculoDestacado.institucionVisitanteNombre">
							<span>{{ espectaculoDestacado.institucionVisitanteNombre }}</span>
						</div>
					</div>
					<div class="titulo-alternativo" v-else>
						{{ espectaculoDestacado.nombre }}
					</div>
					<div class="espectaculo-info" v-if="(espectaculoDestacado.mostrarFecha || espectaculoDestacado.mostrarEscenario) && !espectaculoDestacado.esAbono">
						<div class="fecha-lugar">
							<span class="fecha" v-if="espectaculoDestacado.mostrarFecha">{{ espectaculoDestacado.fechaEscrita }}</span>
							<span class="lugar" v-if="espectaculoDestacado.mostrarEscenario"><img :src="espectaculoDestacado.escenarioLogo">{{ espectaculoDestacado.escenarioNombre }}</span>
						</div>
						<div class="fecha-hora" v-if="espectaculoDestacado.mostrarFecha">{{ espectaculoDestacado.hora }}</div>
					</div>
					<div class="espectaculo-competencia" v-if="espectaculoDestacado.mostrarCompetencia">
						<img :src="espectaculoDestacado.competenciaLogo" :alt="espectaculoDestacado.competenciaNombre">
						<div class="espectaculo-competencia-info">
							<span class="nombre-competencia">{{ espectaculoDestacado.competenciaNombre }}</span>
							<span class="instancia-competencia">{{ espectaculoDestacado.competenciaInstanciaNombre }}</span>
						</div>
					</div>
					<div class="espectaculo-bottom">
						<div class="espectaculo-bottom-right"></div>
					</div>
				</a>
			</div>
			<div class="subheader-right" v-else></div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	// import VueSkeletonLoader from 'skeleton-loader-vue';

	export default {
		data(){
			return {
				isCargandoSubheader: false,
				hayEspectaculoDestacado: false,
				espectaculoDestacado: {
					id: null,
					nombre: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					hora: '',
					escenarioNombre: '',
					escenarioLogo: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					isAgotado: false,
					miniatura: null,
					esAbono: false,
					mostrarCompetencia: true,
					mostrarFecha: true,
					mostrarEscenario: true
				},
				titulo: 'Seguí al decano a todas partes',
				subtitulo: 'EL CLUB GIGANTE'
			}
		},
		// components: {
		// 	VueSkeletonLoader
		// },
		beforeCreate(){
			this.isCargandoSubheader = true
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.cargoTitulos();
			await this.cargoEspectaculo();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			irAEspectaculo(id){
				if(this.espectaculoDestacado.isAgotado === true){
					this.$store.dispatch('mostrarError', '¡Localidades agotadas!')
				} else {
					this.$router.push({ name: 'espectaculo', params: { espectaculoId: parseInt(id) } })
				}
			},
			async cargoEspectaculo(){
				// Obtengo espectáculo destacado
				try {
					let response  = await axios.post('/WSEspectaculoDestacado', {});

					if(response.data.ErrorCod === 0){
						this.hayEspectaculoDestacado = true;
						var data = response.data.SDTEspectaculo;

						this.espectaculoDestacado.id = parseInt(data.EspectaculoId);
						this.espectaculoDestacado.nombre = data.EspectaculoNombre;
						this.espectaculoDestacado.tipoId = parseInt(data.EspectaculoTipoId);
						this.espectaculoDestacado.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculoDestacado.tipoColor = data.EspectaculoTipoColor;
						this.espectaculoDestacado.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculoDestacado.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculoDestacado.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculoDestacado.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculoDestacado.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculoDestacado.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculoDestacado.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculoDestacado.hora = data.EspectaculoHora;
						this.espectaculoDestacado.escenarioNombre = data.EscenarioNombre;
						this.espectaculoDestacado.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculoDestacado.competenciaNombre = data.CompetenciaNombre;
						this.espectaculoDestacado.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculoDestacado.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculoDestacado.isAgotado = data.EspectaculoAgotado;
						this.espectaculoDestacado.miniatura = data.EspectaculoMiniaturaURL;
						this.espectaculoDestacado.esAbono = data.EspectaculoEsAbono;
						this.espectaculoDestacado.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia
						this.espectaculoDestacado.mostrarFecha = data.EspectaculoFrontMostrarFecha
						this.espectaculoDestacado.mostrarEscenario = data.EspectaculoFrontMostrarEscenario
					} else {
						this.hayEspectaculoDestacado = false;
					}

					this.isCargandoSubheader = false;
				} catch (error) {
					this.hayEspectaculoDestacado = false;
					this.isCargandoSubheader = false;
				}
			},
			async cargoTitulos(){
				try {
					let response  = await axios.post('/WSTituloFrontend', {});

					if(response.data.ErrorCod === 0){
						this.titulo = response.data.Titulo
						this.subtitulo = response.data.Subtitulo
					} else {
						this.titulo = 'Seguí al decano a todas partes'
						this.subtitulo = 'EL CLUB GIGANTE'
					}
				} catch (error) {
					this.titulo = 'Seguí al decano a todas partes'
					this.subtitulo = 'EL CLUB GIGANTE'
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	@import url('https://fonts.googleapis.com/css2?family=Staatliches&display=swap');

	.subheader{
		min-height: 620px;
		max-height: 60vh;
		background-color: var(--color-blue);
		background-image: url('https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/portada.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		@include flex(row, center, center);
		position: relative;
		padding-top: 72px;

		&:after{
			content: "";
			width: 100%;
			height: 100%;
			z-index: 0;
			background-color: var(--color-black);
			opacity: 0.55;
			position: absolute;
			top: 0;
			left: 0;
		}

		&:before{
			content: "";
			width: 100%;
			height: 120px;
			background: linear-gradient(180deg,rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);
			position: absolute;
			top: 0;
			left: 0;
		}

		.container{
			width: 100%;
			padding: 0;
			z-index: 1;
			@include flex(row, space-between, flex-end);

			.subheader-left{
				width: calc(100% - 390px);
				padding-right: 10px;

				h1{
					margin: 0;
					color: var(--color-white);
					font-family: var(--font-family-kapra-bold);
					text-transform: uppercase;
					font-size: 100px;
					-webkit-letter-spacing: -1px;
					-moz-letter-spacing: -1px;
					-ms-letter-spacing: -1px;
					letter-spacing: -1px;
					line-height: 90px;
					margin-top: -5px;
					margin-bottom: 5px;
				}

				span.subheader-subtitle{
					display: block;
					color: var(--color-blue-light);
					font-family: var(--font-family-poppins);
					font-weight: var(--font-weight-bold);
					text-transform: uppercase;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					font-size: 20px;
					line-height: 24px;
					// margin-bottom: 12px;
				}
			}

			.subheader-right{
				width: 390px;
				padding-left: 10px;

				.destacado-title{
					color: var(--color-white);
					font-weight: var(--font-weight-regular);
					font-size: 15px;
					text-align: left;
					margin: 0 0 10px 0;
					display: flex;
					font-family: var(--font-family-fira);
				}

				.destacado{
					width: 100%;
					min-height: 286px;
					background-color: var(--color-white);
					-webkit-box-shadow: 0px 0px 53px -9px rgba(0,0,0,0.65);
					-moz-box-shadow: 0px 0px 53px -9px rgba(0,0,0,0.65);
					box-shadow: 0px 0px 53px -9px rgba(0,0,0,0.65);
					border-radius: 0px;
					padding: 25px;
					padding-bottom: 35px;
					position: relative;
					cursor: pointer;
					transition: all .2s;
					text-decoration: none;
					@include flex(column, flex-start, flex-start);

					&.espectaculo-agotado{
						.espectaculo-tipo{
							background-color: rgba(0, 0, 0, 0.4) !important;
							color: var(--color-grey);
							background-color: rgba(0, 0, 0, 0.4);
						}

						.espectaculo-bottom{
							background-color: rgba(0, 0, 0, 0.4);

							.espectaculo-bottom-right{
								background-color: rgba(0, 0, 0, 0.4);
							}
						}

						.espectaculo-agotado-overlay{
							position: absolute;
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
							@include flex(column, center, center);
							background-color: rgba(0, 0, 0, 0.4);

							span{
								color: var(--color-white);
								font-weight: var(--font-weight-bold);
								font-size: 17px;
								font-family: var(--font-family-poppins);
								padding: 8px 10px;
								text-transform: uppercase;
								background-color: var(--color-red);
								transform: rotate(-20deg);
								-webkit-transform: rotate(-20deg);
							}
						}
					}

					.espectaculo-tipo{
						position: absolute;
						top: -27px;
						right: 0px;
						border-radius: 44px;
						padding: 3px 12px;
						background-color: var(--color-red);
						color: var(--color-white);
						font-size: 10px;
						line-height: 1.3em;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
					}

					.espectaculo-top{
						@include flex(row, space-around, flex-start);
						margin: 0;
						padding: 0;
						padding-bottom: 25px;
						width: 100%;

						.equipo{
							@include flex(column, flex-start, center);
							width: calc(50% - 15px);

							img{
								height: 64px;
								width: auto;
							}

							span{
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								font-size: 15px;
								color: var(--color-blue-dark);
								text-align: center;
								line-height: 1.3em;
								margin-top: 10px;
								min-height: 32px;
								-webkit-letter-spacing: -0.4px;
								-moz-letter-spacing: -0.4px;
								-ms-letter-spacing: -0.4px;
								letter-spacing: -0.4px;
								text-transform: uppercase;
								@include flex(column, center, center);
							}
						}

						span.vs{
							font-family: var(--font-family-fira);
							color: var(--color-red);
							font-weight: var(--font-weight-bold);
							text-align: center;
							line-height: 1.2em;
							font-size: 20px;
							max-width: 30px;
							@include flex(column, center, center);
							height: 64px;
						}

						.espectaculo-miniatura{
							height: 70px;
							margin-bottom: -20px;
						}
					}

					.espectaculo-info{
						width: 100%;
						@include flex(row, center, center);
						margin-bottom: 20px;

						.fecha-lugar{
							@include flex(column, center, flex-start);

							.fecha{
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								color: var(--color-blue-dark);
								font-family: var(--font-family-fira);
								line-height: 1.3em;
							}

							.lugar{
								font-weight: var(--font-weight-bold);
								font-size: 14px;
								color: var(--color-blue-dark);
								font-family: var(--font-family-fira);
								line-height: 1.3em;

								img{
									margin-right: 7px;
									width: 28px;
									height: auto;
								}
							}
						}

						.fecha-hora{
							color: var(--color-blue-dark);
							font-size: 20px;
							padding-left: 10px;
							border-left: 1px solid var(--color-blue-dark);
							margin-left: 20px;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
						}
					}

					.espectaculo-competencia{
						width: 100%;
						@include flex(row, center, center);

						img{
							max-height: 28px;
							width: auto;
							margin-right: 15px;
						}

						.espectaculo-competencia-info{
							@include flex(column, center, flex-start);

							.nombre-competencia{
								color: var(--color-blue-dark);
								font-size: 13px;
								font-weight: var(--font-weight-bold);
								font-family: var(--font-family-fira);
								line-height: 1.3em;
							}

							.instancia-competencia{
								color: var(--color-blue-dark);
								font-size: 12px;
								font-weight: var(--font-weight-regular);
								font-family: var(--font-family-fira);
								line-height: 1.3em;
							}
						}
					}

					.espectaculo-bottom{
						width: 100%;
						background-color: var(--color-blue-dark);
						height: 10px;
						border-radius: 0px;
						position: absolute;
						bottom: 0;
						left: 0;
						padding: 0 20px;
						margin: 0;
					}

					.espectaculo-bottom-right{
						width: 50%;
						background-color: var(--color-red);
						height: 10px;
						border-radius: 0px;
						position: absolute;
						bottom: 0;
						right: 0;
						padding: 0 20px;
						margin: 0;
					}

					&.destacado-alternativo{
						// background-color: #11244c;
						@include flex(column, space-evenly, flex-start);

						.titulo-alternativo{
							font-family: var(--font-family-poppins);
							color: var(--color-blue-dark);
							line-height: 1.2em;
							font-size: 26px;
							font-weight: var(--font-weight-bold);
							text-align: center;
							width: 100%;
							text-transform: uppercase;
							margin-bottom: 15px;
						}

						.espectaculo-info{
							margin-bottom: 0px;
						}
					}

					&.espectaculo-abono{
						background-color: var(--color-red);
						border-radius: 12px;

						.titulo-alternativo{
							color: var(--color-white);
							line-height: 1.2em;
							font-size: 38px;
							text-align: center;
							width: 100%;
							margin-bottom: 0px;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
						}

						.espectaculo-bottom{
							border-radius: 0px 0px 12px 12px;
							background-color: var(--color-blue);
							height: 10px;

							.espectaculo-bottom-right{
								background-color: var(--color-white);
								border-radius: 0px 0px 12px 0px;
								height: 10px;
							}
						}
					}

					&:hover{
						-webkit-box-shadow: 0px 0px 53px -9px rgba(0,0,0,1);
						-moz-box-shadow: 0px 0px 53px -9px rgba(0,0,0,1);
						box-shadow: 0px 0px 53px -9px rgba(0,0,0,1);
					}
				}
			}
		}

		@keyframes grow-effect {
			0% {
				width: 0;
				height: 0;
				opacity: 1
			}
			50% {
				width: 0;
				height: 0;
				opacity: 1
			}
			100% {
				width: 180%;
				height: 180%;
				opacity: 0
			}
		}
	}
	
	/* Responsive */
	@media screen and (max-width: 1300px){
		.subheader{
			.container{
				padding-left: 24px;
				padding-right: 24px;
			}
		}
	}

	@media screen and (max-width: 1130px){
		.subheader .container .subheader-left h1{
			margin-top: -20px;
		}
	}

	@media screen and (max-width: 960px){
		.subheader .container .subheader-left span.subheader-subtitle{
			font-size: 16px;
			font-weight: bold;
			line-height: 20px;
		}

		.subheader .container .subheader-left h1{
			font-size: 60px;
			line-height: 56px;
			text-transform: uppercase;
			font-weight: lighter;
			margin-top: -12px;
		}

		.subheader{
			// min-height: 100vh;
			height: auto;
		}

		.subheader .container{
			@include flex(column, flex-start, center);
			padding-top: 76px;
			padding-bottom: 30px;
			height: 100%;
		}

		.subheader .container .subheader-left{
			width: 100%;
			// max-width: 390px;
			margin-bottom: 15px;
			padding-right: 0px;
		}

		.subheader .container .subheader-right{
			width: auto;
			// max-width: 390px;
			margin-top: 15px;
			padding-left: 0px;
		}
	}

	@media screen and (max-width: 520px){
		.subheader .container .subheader-right{
			width: 100%;
		}
	}

	@media screen and (max-width: 500px){
		.subheader .container .subheader-left span.subheader-subtitle{
			font-size: 14px;
			font-weight: bold;
			line-height: 20px;
		}

		.subheader .container .subheader-left h1{
			font-size: 48px;
			line-height: 48px;
			text-transform: uppercase;
			font-weight: lighter;
			margin-top: -12px;
		}
	}

	@media screen and (max-width: 460px){
		.subheader{
			.container{
				.subheader-right{
					.destacado{
						min-height: auto;
						.espectaculo-top{
							span.vs{
								font-size: 15px;
							}

							.equipo{
								img{
									height: 46px;
								}

								span{
									font-size: 13px;
								}
							}
						}

						.espectaculo-info{
							.fecha-lugar{
								.fecha{
									font-size: 12px;
								}

								.lugar{
									font-size: 12px;

									img{
										width: 20px;
										margin-right: 5px;
									}
								}
							}

							.fecha-hora{
								font-size: 16px;
							}
						}

						.espectaculo-competencia{
							img{
								max-height: 24px;
							}

							.espectaculo-competencia-info{
								.nombre-competencia{
									font-size: 12px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>